import DynamicImage from "../DynamicImages/DynamicImage";
import { usePathname } from 'next/navigation';
import { Button } from "../ui/button";
import Link from "next/link";
import { allBrandList } from "@/components/BrandDetail/arraybrandlist";
import { useDispatch } from "react-redux";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";
import { brandList } from "@/lib/brandData";

const Category = ({ brandName }) => {
  const pathname = usePathname();
  const dispatch = useDispatch();

  const DataResponse = allBrandList.find((item) => item[brandName])?.[
    brandName
  ];

  const brandListOptions = Array.isArray(DataResponse?.brandOptions)
    ? DataResponse.brandOptions
    : [];
   

  if (!brandListOptions || brandListOptions.length === 0) return null;

  const brandNameMapping = new Map([
    ["U_Line", "U-Line"],
    ["Lg", "LG"],
    ["Lg_Studio", "LG Studio"],
    ["Kitchenaid", "KitchenAid"],
    ["Ge_Profile", "GE Profile"],
    ["Ge_Appliances", "GE"],
  ]);

  let formattedBrandName =
    brandNameMapping.get(brandName) ||
    brandName
      .replace(/Appliances/g, "")
      .replace(/_/g, " ")
      .trim();

  const shopAllClick = brandName.replace(/_/g, "-");

  const updateBreadcrumb = (breadcrumb) => {
    dispatch(AddNewBreadcrum(breadcrumb));
  };

  const href = `/all-brands/${shopAllClick.toLowerCase()}`;
  const brandDetails = brandList
  .filter((item) => pathname?.includes(item.link))
  .sort((a, b) => b.link.length - a.link.length)
  .shift();

  return (
    <div className="bg-light-gray">
      <div className="max-w-[1225px] mx-auto px-4  pt-[10px]">
        {brandName !== "Cove" &&
          brandName !== "Wolf" &&
          brandName !== "Sub_Zero" && (
            <div className="flex justify-between items-center gap-2 py-4 flex-wrap">
              <h4 className="text-[30px] font-semibold smd:text-[24px]">
                Explore {formattedBrandName} Appliances
              </h4>
              <Link
                href={href}
                onClick={() =>
                  updateBreadcrumb([
                    { name: "All Brands", url: "/brands" },
                    brandDetails ? { name: brandDetails.name, url: `/${brandDetails.link}` } : null,
                    { name: "Shop All", url: href },
                  ].filter(Boolean))
                }
              >
                <Button className="rounded-[40px] px-8 font-semibold text-[16px] bg-[#0B223C] h-11">
                  Shop All
                </Button>
              </Link>
            </div>
          )}
        <div
          className={` ${
            brandListOptions[0]?.fullImage
              ? "flex justify-between py-[54px] md:grid md:grid-cols-1 md:justify-items-center "
              : "flex justify-center pt-[10px] pb-[34px] flex-wrap"
          }  grid-cols-204 gap-x-[13px] gap-y-[38px]  my-0 mx-auto `}
        >
          {brandListOptions.map((item, index) => (
            <Link
              href={item?.slug}
              onClick={() =>
                updateBreadcrumb([
                  { name: "All Brands", url: "/brands" },
                  brandDetails ? { name: brandDetails.name, url: `/${brandDetails.link}` } : null,
                  { name: item.title, url: item?.slug },
                ].filter(Boolean))
              }
              key={index}
              className={`shadow-typeCardBg overflow-hidden  bg-[#fff] rounded-[15px] flex flex-col w-full  items-center   ${
                item?.fullImage
                  ? "pt-0 min-h-[222px] max-w-[335px] relative"
                  : "pt-[27px] min-h-[302px] justify-end max-w-[228px] "
              } `}
            >
              <div
                className={`flex   ${
                  item?.imageFlag ? " items-center " : "items-end"
                } ${
                  item?.fullImage
                    ? " relative w-full h-[177px]  p-0 pb-[53%]"
                    : " px-[10px]  h-full"
                }`}
              >
                <DynamicImage
                  src={item.img}
                  className={` ${
                    item?.fullImage
                      ? "object-cover absolute top-0 bottom-0 left-0 right-0 h-full w-full "
                      : " h-auto  object-contain"
                  }`}
                  alt="type"
                />
              </div>
              <div className={`${item?.fullImage ? "px-7 pb-[10px]" : ""}`}>
                <p
                  className={`pt-[20px] pb-[14px] ${
                    item?.fullImage
                      ? " bg-white w-full text-[20px] font-semibold"
                      : "text-center underline text-[14px] font-medium   "
                  }`}
                >
                  {item.title}
                </p>
                {item?.fullImage && <p className="text-[14px]">{item?.desc}</p>}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Category;